module.exports = __webpack_public_path__ + "static/img/payment-fail.b779f091.png";